import Qna from "component/qna/Qna";
import Stream from "component/stream/Stream";
import { condition } from "context/condition";
import { Globalstate } from "context/context";
import usePrompts from "hooks/usePrompts";
import React from "react";
import { useQuery } from "react-query";

const HomeRoutes = () => {
  const { dispatch } = Globalstate();
  const { state } = Globalstate();

  const { data, error } = useQuery("prompts", usePrompts, {
    retry: 0,
    staleTime: Infinity, // Prevents refetching
    cacheTime: Infinity, // Keeps the data in cache indefinitely,
    onSuccess: (data) => {
      if (state.source === "service") {
        dispatch({
          type: condition.SETPROMPTS,
          payload: data?.docs?.service
        });
      } else {
        dispatch({
          type: condition.SETPROMPTS,
          payload: data?.docs?.abcd
        });
      }
    },
    onError: (err) => {
      console.log("Error:", err?.message);
    }
  });

  return state?.mode === "qna" ? <Qna /> : <Stream />;
};

export default HomeRoutes;
